import { useState } from "react"
import BlueTableHeading from "../../../common/AdminCommonComponents/BlueTableHeading/BlueTableHeading"
import ActionButton from "../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton"
import DynamicButton from "../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDatatable from "../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import GrayDivider from "../../../common/AdminCommonComponents/GrayDivider/GrayDivider"
import LightGrayBgWrapper from "../../../common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import DynamicCardRow from "../../DynamicCardRow/DynamicCardRow"
import styles from "./LoyaltyAndRewards.module.scss"
import CustomModal from "../../../common/AdminCommonComponents/CustomModal/CustomModal"
import Toggle from "../../../common/AdminCommonComponents/Toggle/Toggle"
import { Input } from "reactstrap"
import Avatar1 from '../../../../assets/images/AdminPortal/FBMManagement/customer-avatar-1.png'
import Avatar2 from '../../../../assets/images/AdminPortal/FBMManagement/customer-avatar.png'
import FullNameAvatar from "../../../common/AdminCommonComponents/FullNameAvatar/FullNameAvatar"

const LoyaltyAndRewards = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const actions = [
    { label: "View Details", action: () => console.log("View details") },
    { label: "Edit", action: () => console.log("Edit") },
    { label: "Delete", action: () => console.log("Delete") },
  ]

  const statsData = [
    { title: "Total Loyalty points earned".toUpperCase(), value: 0 },
    { title: "Loyalty points redeemed".toUpperCase(), value: 0 },
    { title: "Available points".toUpperCase(), value: 0 },
  ]

  const tableData = [
    { sr: 1, customerID: { img: Avatar1, name: 'C-000' }, customerName: "Full Name", pointsEarned: 50, pointsRedeemed: 30, availablePoints: 20, expirationDate: "June 9,2023" },
    { sr: 1, customerID: { img: Avatar2, name: 'C-000' }, customerName: "Full Name", pointsEarned: 50, pointsRedeemed: 30, availablePoints: 20, expirationDate: "June 9,2023" },
    { sr: 1, customerID: { img: Avatar1, name: 'C-000' }, customerName: "Full Name", pointsEarned: 50, pointsRedeemed: 30, availablePoints: 20, expirationDate: "June 9,2023" },
    { sr: 1, customerID: { img: Avatar2, name: 'C-000' }, customerName: "Full Name", pointsEarned: 50, pointsRedeemed: 30, availablePoints: 20, expirationDate: "June 9,2023" },
    { sr: 1, customerID: { img: Avatar1, name: 'C-000' }, customerName: "Full Name", pointsEarned: 50, pointsRedeemed: 30, availablePoints: 20, expirationDate: "June 9,2023" },
  ]

  const columns = [
    { name: "Sr. No", selector: (row) => row.sr, grow: 0.3 },
    { name: "Customer ID", cell: (row) => <FullNameAvatar fullName={row.customerID.name} src={row.customerID.img} /> },
    { name: "Customer Name", selector: row => row.customerName },
    { name: "Points Earned", selector: (row) => row.pointsEarned },
    { name: "Points Redeemed", selector: (row) => row.pointsRedeemed },
    { name: "Available Points", selector: (row) => row.availablePoints },
    { name: "Expiration Date", selector: (row) => row.expirationDate },
    { name: "Action", cell: () => <ActionButton options={actions} />, center: 'true' },
  ]

  return (
    <LightGrayBgWrapper>
      <div className="bg-white shadow px-4 p-3">
        <div className="fw-semibold fs-5 mb-2">Overview</div>
        <DynamicCardRow cards={statsData} />
      </div>

      <div className="bg-white shadow mt-3 px-4 p-3">
        <div className="d-flex align-items-center justify-content-between">
          <BlueTableHeading className="fw-semibold fs-5">Points Overview</BlueTableHeading>
          <DynamicButton theme="blue" onClick={() => setIsModalOpen((prev) => !prev)}>
            Points Conversion
          </DynamicButton>
        </div>

        <div className="my-3">
          <GrayDivider />
        </div>

        <DynamicDatatable columns={columns} data={tableData} type="gray" pagination />
      </div>

      {isModalOpen && (
        <CustomModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen((prev) => !prev)}
          body={
            <div className={styles.modal}>
              <h2 className={styles.title}>Points Conversion</h2>
              <div className="d-flex">
                <Input type="number" placeholder="Value ($)" className={`${styles.input} ${styles.leftSideRounded}`} />
                <Input type="number" placeholder="Points" className={`${styles.input} ${styles.rightSideRounded}`} />
              </div>

              <div className={styles.controls}>
                <Toggle />
                <DynamicButton theme="blue">Set</DynamicButton>
              </div>
            </div>
          }
        />
      )}
    </LightGrayBgWrapper>
  )
}

export default LoyaltyAndRewards
